module.exports = __webpack_public_path__ + "static/media/press_content_04.2632c7ed.png";